import { defineTextStyles } from "@chakra-ui/react";

const display = {
  1: {
    description: "Display 1",
    value: {
      fontFamily: "komu",
      fontSize: "11xl",
      fontWeight: "normal",
      lineHeight: "1.25",
      letterSpacing: "normal"
    }
  },
  2: {
    description: "Display 2",
    value: {
      fontFamily: "komu",
      fontSize: "10xl",
      fontWeight: "normal",
      lineHeight: "1.28",
      letterSpacing: "normal"
    }
  },
  3: {
    description: "Display 3",
    value: {
      fontFamily: "komu",
      fontSize: "9xl",
      fontWeight: "normal",
      lineHeight: "normal",
      letterSpacing: "normal"
    }
  },
  4: {
    description: "Display 4",
    value: {
      fontFamily: "komu",
      fontSize: "8xl",
      fontWeight: "normal",
      lineHeight: "normal",
      letterSpacing: "normal"
    }
  },
  5: {
    description: "Display 5",
    value: {
      fontFamily: "komu",
      fontSize: "7xl",
      fontWeight: "normal",
      lineHeight: "normal",
      letterSpacing: "normal"
    }
  },
  6: {
    description: "Display 6",
    value: {
      fontFamily: "komu",
      fontSize: "6xl",
      fontWeight: "normal",
      lineHeight: "normal",
      letterSpacing: "normal"
    }
  }
};

const title = {
  1: {
    description: "Title 1",
    value: {
      fontFamily: "infini",
      fontSize: "5xl",
      fontWeight: "bold",
      lineHeight: "1.36",
      letterSpacing: "normal"
    }
  },
  2: {
    description: "Title 2",
    value: {
      fontFamily: "infini",
      fontSize: "3xl",
      fontWeight: "bold",
      lineHeight: "1.36",
      letterSpacing: "normal"
    }
  },
  3: {
    description: "Title 3",
    value: {
      fontFamily: "infini",
      fontSize: "xl",
      fontWeight: "bold",
      lineHeight: "1.37",
      letterSpacing: "normal"
    }
  },
  4: {
    description: "Title 4",
    value: {
      fontFamily: "infini",
      fontSize: "lg",
      fontWeight: "bold",
      lineHeight: "normal",
      letterSpacing: "0.056rem" // 0.9px
    }
  },
  5: {
    description: "Title 5",
    value: {
      fontFamily: "infini",
      fontSize: "md",
      fontWeight: "bold",
      lineHeight: "1.56",
      letterSpacing: "normal"
    }
  },
  6: {
    description: "Title 6",
    value: {
      fontFamily: "infini",
      fontSize: "sm",
      fontWeight: "bold",
      lineHeight: "1.71",
      letterSpacing: "normal"
    }
  }
};

const heading = {
  large: {
    description: "Large",
    value: {
      fontFamily: "inter",
      fontSize: "4xl",
      fontWeight: "normal",
      lineHeight: "1.47",
      letterSpacing: "normal"
    }
  },
  standard: {
    description: "Standard",
    value: {
      fontFamily: "inter",
      fontSize: "2xl",
      fontWeight: "normal",
      lineHeight: "1.42",
      letterSpacing: "normal"
    }
  },
  small: {
    description: "Small",
    value: {
      fontFamily: "inter",
      fontSize: "xl",
      fontWeight: "normal",
      lineHeight: "1.5",
      letterSpacing: "normal"
    }
  }
};

const body = {
  large: {
    description: "Body Large",
    value: {
      fontFamily: "inter",
      fontSize: "md",
      fontWeight: "normal",
      lineHeight: "1.5",
      letterSpacing: "normal"
    }
  },
  standard: {
    description: "Body Standard",
    value: {
      fontFamily: "inter",
      fontSize: "sm",
      fontWeight: "normal",
      lineHeight: "1.43",
      letterSpacing: "normal"
    }
  },
  small: {
    description: "Body Small",
    value: {
      fontFamily: "inter",
      fontSize: "xs",
      fontWeight: "normal",
      lineHeight: "1.67",
      letterSpacing: "normal"
    }
  }
};

const folio = {
  standard: {
    description: "Folio Standard",
    value: {
      fontFamily: "inter",
      fontSize: "2xs",
      fontWeight: "normal",
      lineHeight: "1.6",
      letterSpacing: "normal"
    }
  }
};

const buttonLabel = {
  large: {
    description: "Primary button label",
    value: {
      fontFamily: "inter",
      fontSize: "md",
      fontWeight: "600",
      lineHeight: "1.25",
      letterSpacing: "normal"
    }
  },
  standard: {
    description: "Secondary button label",
    value: {
      fontFamily: "inter",
      fontSize: "sm",
      fontWeight: "600",
      lineHeight: "0.625rem", // 10px
      letterSpacing: "normal"
    }
  },
  small: {
    description: "Tertiary button label",
    value: {
      fontFamily: "inter",
      fontSize: "xs",
      fontWeight: "600",
      lineHeight: "0.563rem", // 9px
      letterSpacing: "normal"
    }
  }
};

const tag = {
  large: {
    description: "Tag Label Large",
    value: {
      fontFamily: "inter",
      fontSize: "sm",
      fontWeight: "500",
      lineHeight: "0.86",
      letterSpacing: "0.375rem", // 6px
      textTransform: "uppercase"
    }
  },
  standard: {
    description: "Tag Label Standard",
    value: {
      fontFamily: "inter",
      fontSize: "xs",
      fontWeight: "500",
      lineHeight: "normal",
      letterSpacing: "0.25rem", // 4px
      textTransform: "uppercase"
    }
  },
  small: {
    description: "Tag Label Small",
    value: {
      fontFamily: "inter",
      fontSize: "2xs",
      fontWeight: "500",
      lineHeight: "1.2",
      letterSpacing: "0.125rem", // 2px
      textTransform: "uppercase"
    }
  }
};

const print = {
  standard: {
    description: "Standard",
    value: {
      fontFamily: "inter",
      fontSize: "3xs",
      fontWeight: "normal",
      lineHeight: "1.33",
      letterSpacing: "normal"
    }
  },
  small: {
    description: "Small",
    value: {
      fontFamily: "inter",
      fontSize: "4xs",
      fontWeight: "normal",
      lineHeight: "1.25",
      letterSpacing: "normal"
    }
  }
};

const printCaption = {
  caption: {
    description: "Caption",
    value: {
      fontFamily: "inter",
      fontSize: "4xs",
      fontWeight: "600",
      lineHeight: "1.43",
      letterSpacing: "0.088rem", // 1.4px
      textTransform: "uppercase"
    }
  }
};

const code = {
  large: {
    description: "Code Large",
    value: {
      fontFamily: "courier-prime, courier",
      fontSize: "md",
      fontWeight: "normal",
      lineHeight: "1.125",
      letterSpacing: "0.125rem" // 2px
    }
  }
};

export const textStyles = defineTextStyles({
  body,
  buttonLabel,
  code,
  display,
  folio,
  heading,
  print,
  printCaption,
  tag,
  title
});
